<template>
    <div>
        <div class="rubrique" data-aos="fade-right">
            <article class="media">
                <figure class="media-left is-hidden-mobile">
                    <p class="image is-128x128">
                        <img alt="AEMP logo" width="128" src="../assets/bulb.svg">
                    </p>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <h3 class="title is-4">L'association</h3>
                        <p>L'acte fondateur a eu lieu dans les suites du premier congrès national des équipes mobiles « Quelles perspectives pour les adolescents ? » qui s'est tenu à Lille en 2008. Il était porté par le Docteur Vincent Garcin et le Professeur Sylvie Tordjman, tous deux pédopsychiatres engagés dans le développement de dispositifs innovants « pour aller à la rencontre des jeunes en difficulté psychologique et leur permettre d'accéder aux soins » . Ils ont été respectivement élus Président et Vice-Présidente de l'AEMP. La première assemblée générale était composée de professionnels de Pédopsychiatrie et Psychiatrie adulte, de représentants d'usagers et de famille d'usagers tous impliqués dans des dispositifs visant à favoriser l'accès aux soins et/ou leur continuité.</p>
                        <p>Les équipes mobiles, aujourd'hui nombreuses, interviennent dans des cadres très diversifiés (urgence psychiatrique, psychiatrie adulte, psychiatrie du sujet âgé, précarité, psychiatrie de l'adolescent, psychiatrie périnatale et petite enfance, familles en difficulté d'accès à la parentalité, ou encore violence intrafamiliale incluant les violences conjugales). Elles permettent de rencontrer le sujet en souffrance dans son contexte familial, conjugal, social et économique, en s'étayant sur ses potentielles ressources mais aussi sur celles de son environnement familial et social. Alors que se développe l'idée « du savoir expérientiel », l'AEMP propose de partager le savoir expérientiel d'une pratique clinique plurielle, pour une psychiatrie plus humaniste.</p>
                    </div>
                </div>
                <div class="media-right">
                </div>
            </article>
        </div>
        <div class="rubrique" data-aos="fade-left">
            <h3 class="title is-4">Bureau</h3>
            <div style="overflow-x: auto;">
                <Bureau />
            </div>
        </div>
        <div class="rubrique" data-aos="fade-left">
            <article class="media">
                <div class="media-content">
                    <div class="content">
                        <h3 class="title is-4">Equipes Mobiles et Référents</h3>
                        <div v-if="loading_referents" class="loading">
                            Loading...
                        </div>
                        <span v-if="referents" v-html=" referents.referents"></span>
                    </div>
                </div>
            </article>
        </div>
        <div class="rubrique" data-aos="fade-left">
            <article class="media">
                <div class="media-content">
                    <div class="content">
                        <h3 class="title is-4">Publications</h3>
                        Nous mettons à votre disposition une collection de ressources (articles de presse, publications, diaporamas, liens...etc), régulierement mise à jour, sur la psychiatrie et les équipes mobiles.
                        <p class="has-text-left">
                            Voir notre
                            <router-link to="/page/publications"><b>sélection de publications</b></router-link>
                        </p>
                    </div>
                </div>
                <div class="media-right">
                    <p class="image is-128x128">
                        <img alt="AEMP logo" width="128" src="../assets/publis.svg">
                    </p>
                </div>
            </article>
        </div>
        <div class="rubrique" data-aos="zoom-in">
            <h3 class=" title is-4 has-text-left">Congrès national des équipes mobiles</h3>
            <div style="overflow-x: auto;">
                <Congres />
            </div>
        </div>
        <div class="rubrique">
            <h3 class="title is-4 ">A la une!</h3>
            <Carousel />
        </div>
    </div>
</template>
<script>
import 'aos/dist/aos.css';
import Carousel from './Carousel.vue'
import Bureau from './Bureau.vue'
import Congres from './Congres.vue'
import AOS from 'aos';
AOS.init()
const axios = require('axios');
export default {
    data: function() {
        return {
            loading_referents: true,
            error: null,
            referents: null,
        }
    },
    name: 'Landing',
    components: {
        Carousel,
        Bureau,
        Congres
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.referents = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_referents
            axios({
                    method: 'get',
                    url: fetchurl
                }).then(function(response) {
                    vm.loading_referents = false
                    vm.referents = response.data
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'liste des référents introuvable'
                })

        }
    }
}
</script>
<style scoped>
.rubrique {
    margin-bottom: 55px;
}

th {
    background-color: #eee;
}
</style>